// extracted by mini-css-extract-plugin
export var formContainer = "_kg-0";
export var message = "_kg-1";